











































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Marker } from '@/models/Retailer';
import { mapMutations } from 'vuex';
import http from '@/services/Http';
import { MarkersStore } from '@/store/markersstate';

@Component
export default class RetailerSearchBox extends Vue {
    @Prop()
    protected showFilter!: boolean;

    protected searchQuery: string = this.getQuerystring('q');
    protected searched: boolean = false;
    protected showFilterSelection: boolean = false;
    protected t: any = null;
    protected gaggenau: string = this.getQuerystring('gaggenau');

    constructor() {
        super();
    }

    mounted() {
        if (this.showFilter) {
            this.search();
        }
    }

    private search() {
        const markers: Marker[] = [];
        this.setQuerystrings('q', this.searchQuery);
        const retailers = http.get(
            `/api/retailer?query=${this.searchQuery}&t=${this.t}&gaggenau=${this.gaggenau}&pagesize=all&exclude=true`
        );
        retailers.then((response: any) => {
            const data = response.json();
            data.then((retailerList: any[]) => {
                // console.log(retailerList);
                retailerList.forEach((item: Marker) => {
                    if (
                        item != null &&
                        item.position != null &&
                        item.position.lat != null &&
                        item.position.lng != null
                    ) {
                        markers.push(item);
                    } else {
                        //   console.log(item.name + ' is missing position');
                    }
                });
                MarkersStore.searchRetailer(markers);
            }).catch((e: any) => {
                console.error(e);
            });
        });
    }
    private selectRetailer(index: number) {
        this.mapMarkers.map(marker => {
            marker.selected = false;
        });
        this.mapMarkers[index].selected = true;
        this.$emit('clicked', this.mapMarkers[index], index);
    }

    private toggleFilter() {
        this.showFilterSelection = !this.showFilterSelection;
    }

    @Watch('mapMarkers')
    private hasSearched() {
        if (this.searchQuery.length > 0) {
            this.searched = true;
        } else {
            this.searched = false;
        }
    }

    get mapMarkers(): Marker[] {
        return MarkersStore.getMarkers;
    }

    private setQuerystrings(att: string, value?: string) {
        let currentQuery = JSON.parse(JSON.stringify(this.$route.query));

        if ((value == null || value == undefined || value == '') && currentQuery[att] != undefined) {
            delete currentQuery[att];
        } else if (value != null && value != undefined && value != '') {
            currentQuery[att] = value;
        }

        const route = {
            path: this.$route.params[0],
            query: currentQuery
        };

        this.$router.replace(route, () => {});
    }

    private getQuerystring(guerystring: string): string {
        if (this.$route.query[guerystring] != null && typeof this.$route.query[guerystring] == 'string') {
            return this.$route.query[guerystring] as string;
        }
        return '';
    }
}
